import React from "react";
import { toggle } from "../../../../util/common";
import { BusinessCreditReportStatePII, IBusinessLicense } from "../../../../store/businessCreditReportService/types";
import { getFormattedDate } from "../../../../util/dateFormatting";
import i18nService from "../../../../util/Internationalization/i18n/i18n";

interface IProps {
    reportObject: BusinessCreditReportStatePII;
    showAsAccordion?: boolean;
}
const CompanyInformationBusinessLicense: React.FunctionComponent<IProps> = (props) => {
    return (
        <React.Fragment>
            <div role="listitem" className="data-row">
                <div className="link-item">
                    {props.showAsAccordion ? (
                        <button
                            type="button"
                            aria-expanded="false"
                            className="link-button"
                            id="btn-business-licenses"
                            onClick={() => toggle("business-licenses-details", "btn-business-licenses")}
                        >
                            <span className="row link-item">
                                <span className="col-xs col-no-gutter link-text">
                                    <span className="link-title">
                                        <span className="btn-toggle-status sr-only">Show</span> Business Licenses
                                    </span>
                                </span>
                            </span>
                        </button>
                    ) : (
                        <h5 className="report-sub-title">Business Licenses</h5>
                    )}

                    <div
                        className="wallet-details"
                        id="business-licenses-details"
                        style={{ ...(props.showAsAccordion ? { display: "none" } : {}) }}
                        aria-hidden="true"
                    >
                        {props.reportObject?.businessCompanyReport?.business_licenses?.map((license: IBusinessLicense, index: number) => (
                            <React.Fragment key={`license-${index}`}>
                                <div role="grid" className="data-grid row-height-xs " aria-labelledby={`business-license-${index}`}>
                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="contact-1-name">
                                                Type
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="contact-1-name">
                                                {license?.type}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="contact-1-name">
                                                Status
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="contact-1-name">
                                                {license?.status}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="contact-1-name">
                                                Body Name
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="contact-1-name">
                                                {license?.body_name}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="contact-1-name">
                                                Jurisdiction
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="contact-1-name">
                                                {license?.jurisdiction}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="contact-1-name">
                                                Start Date
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="contact-1-name">
                                                {getFormattedDate(i18nService.get("Country"), license?.start_date ? license?.start_date : "")}
                                            </div>
                                        </div>
                                    </div>

                                    <div role="row" className="data-row condensed row">
                                        <div role="gridcell" className="col-xs-4 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="contact-1-name">
                                                End Date
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-8 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="contact-1-name">
                                                {getFormattedDate(i18nService.get("Country"), license?.end_date ? license?.end_date : "")}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {props.reportObject?.businessCompanyReport?.business_licenses?.length !== index + 1 && (
                                    <div className="line-divider margin-vertical-xs"></div>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default CompanyInformationBusinessLicense;
